export default __webpack_public_path__ + "static/media/vertical-installation.930e5655.svg";